export enum rentGptActionTypes {
    SET_RG_PROPERTY = 'SET_RG_PROPERTY',
    SET_RG_PROPERTIES = 'SET_RG_PROPERTIES',
}
